//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

}



// WEBPACK FOOTER //
// ./scripts/vue/svg/svgList.vue